import { render } from "./menuAdmin.vue?vue&type=template&id=715d53c5"
import script from "./menuAdmin.vue?vue&type=script&lang=js"
export * from "./menuAdmin.vue?vue&type=script&lang=js"

import exportComponent from "/Users/hamzaassif/Work/detect-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__